var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isFullscreen == true ? 'web-app' : '',attrs:{"id":"app"}},[(_vm.$route.meta.isHaveTop)?_c('body-header'):_vm._e(),_c('router-view'),(_vm.$route.meta.isHaveContact)?_c('contact-us-fixed'):_vm._e(),(_vm.$route.meta.isHaveBottom)?_c('body-footer'):_vm._e(),_c('Dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }